import {mapGetters, mapMutations} from "vuex";
import categoryListCard from "@/components/category-list-card/index.vue";
import productVisibilityMixin from '@/mixins/productVisibilityMixin';
//sections
export default {
    name: "product-carousel",
    components: {
        categoryListCard
    },
    mixins: [productVisibilityMixin],
    data() {
        return {
            hasTrackedCarousel: false, // Флаг для предотвращения повторной отправки
            carouselObserver: null // IntersectionObserver для отслеживания видимости блока
        }
    },
    created() {
    },
    mounted() {
        this.initCarouselTracking();
    },
    beforeDestroy() {
        if (this.carouselObserver) {
            this.carouselObserver.disconnect();
        }
        this.removeEventListeners();
    },
    props: {
        item: {
            list: {
                type: Object,
                default: () => {
                }
            }
        },
        list: {
            type: Array,
            default: () => []
        },
        perPageCustom: {
            type: Array,
            default: () => [[200, 2], [900, 2], [1200, 4], [1440, 4]]
        }
    },
    computed: {
        ...mapGetters({
            currentProduct: 'catalog/currentProduct'
        })
    },
    methods: {
        /**
         * Ініціалізує відстеження для каруселі товарів
         */
        initCarouselTracking() {
            // Встановлюємо контекст списку товарів
            const listName = this.item?.subType ? this.item.title : 'Схожі товари';
            const listId = `carousel-${this.item?.id || 'similar-products'}`;
            // Ініціалізуємо трекер через міксин
            this.initProductTracker(listName, listId);
            // Ініціалізуємо IntersectionObserver для відстеження видимості блоку каруселі
            this.initCarouselVisibilityObserver();
        },
        /**
         * Ініціалізує IntersectionObserver для відстеження видимості блоку каруселі
         */
        initCarouselVisibilityObserver() {
            if (!('IntersectionObserver' in window)) {
                console.warn('IntersectionObserver не підтримується, чекаємо взаємодії користувача');
                this.$nextTick(() => {
                    this.waitForUserInteraction();
                });
                return;
            }
            this.$nextTick(() => {
                // Знаходимо основний блок каруселі (спочатку пробуємо slider-products__wrapper)
                let carouselBlock = this.$el.querySelector('.slider-products__wrapper');
                if (!carouselBlock) {
                    // Fallback до старого селектора
                    carouselBlock = this.$el.querySelector('.slider-products');
                }
                if (!carouselBlock) {
                    console.warn('Блок каруселі не знайдено, чекаємо взаємодії користувача');
                    this.waitForUserInteraction();
                    return;
                }
                // Завжди налаштовуємо observer, незалежно від початкової видимості
                this.setupIntersectionObserver(carouselBlock);
            });
        },
        /**
         * Чекає взаємодії користувача (fallback для випадків без IntersectionObserver)
         */
        waitForUserInteraction() {
            const handleUserInteraction = () => {
                // Видаляємо обробники
                window.removeEventListener('scroll', handleUserInteraction);
                document.removeEventListener('touchstart', handleUserInteraction);
                document.removeEventListener('mousedown', handleUserInteraction);
                document.removeEventListener('keydown', handleUserInteraction);
                // Відправляємо подію
                this.trackCarouselProducts();
            };
            // Додаємо обробники для різних типів взаємодії
            window.addEventListener('scroll', handleUserInteraction, { passive: true });
            document.addEventListener('touchstart', handleUserInteraction, { passive: true });
            document.addEventListener('mousedown', handleUserInteraction, { passive: true });
            document.addEventListener('keydown', handleUserInteraction, { passive: true });
        },
        /**
         * Чекає поки користувач прокрутить сторінку, а потім налаштовує observer
         */
        waitForUserScroll(carouselBlock) {
            // Налаштовуємо observer одразу, але з додатковими перевірками
            this.setupIntersectionObserver(carouselBlock);
        },
        /**
         * Налаштовує IntersectionObserver для блоку каруселі
         */
        setupIntersectionObserver(carouselBlock) {
            this.carouselObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            // Детальна перевірка видимості блоку
                            const rect = entry.boundingClientRect;
                            const viewportHeight = window.innerHeight;
                            // Блок повинен бути в межах viewport
                            const isInViewport = rect.top >= 0 && rect.top < viewportHeight && rect.bottom > 0;
                            // Блок повинен бути видимий на 100%
                            const blockHeight = rect.bottom - rect.top;
                            const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
                            const visibilityRatio = visibleHeight / blockHeight;
                            const isSignificantlyVisible = visibilityRatio >= 1.0;
                            if (isInViewport && isSignificantlyVisible) {
                                this.trackCarouselProducts();
                                // Відключаємо observer після першого спрацювання
                                if (this.carouselObserver) {
                                    this.carouselObserver.disconnect();
                                    this.carouselObserver = null;
                                }
                            }
                        }
                    });
                },
                {
                    root: null, // viewport
                    rootMargin: '0px',
                    threshold: 1.0 // Блок вважається видимим, коли 100% його площі видно
                }
            );
            // Починаємо відстеження
            this.carouselObserver.observe(carouselBlock);
        },
        /**
         * Відстежує товари в каруселі
         */
        trackCarouselProducts() {
            if (!this.productTracker || !this.list || this.list.length === 0) {
                console.warn('ProductCarousel - не можна відстежити товари:', {
                    hasTracker: !!this.productTracker,
                    hasList: !!this.list,
                    listLength: this.list?.length || 0
                });
                return;
            }
            // Використовуємо новий метод для відстеження slider контейнера
            const listName = this.item?.subType ? this.item.title : 'Схожі товари';
            const listId = `carousel-${this.item?.id || 'similar-products'}`;
            
            this.trackSliderProducts(this.list, '.slider-products__wrapper', listName, listId);
        },
        /**
         * Відправляє view_item_list для всіх товарів каруселі одним подією
         */
        sendCarouselViewItemList(products) {
            if (!products || products.length === 0) {
                console.warn('ProductCarousel - немає товарів для відправки');
                return;
            }
            // Перевіряємо, чи вже відправляли подію для цієї каруселі
            if (this.hasTrackedCarousel) {
                return;
            }
            // Форматуємо всі товари
            const formattedProducts = products.map(product => {
                return this.formatProductForGA(product);
            });
            // Відправляємо одне подію з усіма товарами
            this.sendToDataLayer(formattedProducts);
            // Позначаємо, що подію вже відправлено
            this.hasTrackedCarousel = true;
        },
        /**
         * Форматує товар для Google Analytics
         */
        formatProductForGA(product) {
            const price = this.extractPrice(product);
            // Визначаємо назву товару
            let itemName = product.title || product.name || '';
            if (!itemName && product.id) {
                itemName = `Товар ${product.id}`;
            }
            // Визначаємо бренд
            let finalBrand = product.productBrand?.title || 
                            product.brand?.title || 
                            product.manufacturer?.title || '';
            if (!finalBrand && itemName) {
                finalBrand = this.extractBrandFromTitle(itemName);
            }
            // Визначаємо категорію
            let category = product.category?.name || product.category?.title || '';
            if (!category) {
                // Спробуємо отримати з роуту
                const routeCategory = this.getCurrentCategoryFromRoute();
                if (routeCategory) {
                    category = this.getCategoryNameFromCatalog(routeCategory);
                }
            }
            return {
                item_name: itemName,
                item_id: this.normalizeId(product.id),
                price: price,
                currency: 'UAH',
                item_brand: finalBrand || 'Невизначений бренд',
                item_category: category || 'Невизначена категорія'
            };
        },
        /**
         * Витягує ціну з даних товару
         */
        extractPrice(product) {
            if (product.productPrice) {
                const priceData = product.productPrice;
                if (priceData.baseUnit?.isM2) {
                    return parseFloat(priceData.price?.priceM2 || 0);
                } else {
                    return parseFloat(priceData.price?.price || 0);
                }
            }
            return 0;
        },
        /**
         * Витягує бренд з заголовка товару
         */
        extractBrandFromTitle(title) {
            if (!title) return '';
            const t = (title || '').trim();
            if (!t) return '';
            const commaIdx = t.indexOf(',');
            if (commaIdx > 0) {
                const beforeComma = t.slice(0, commaIdx).trim();
                if (beforeComma.length >= 2 && beforeComma.length <= 60) return beforeComma;
            }
            const capsMatch = t.match(/\b[A-ZА-ЯЇІЄҐ]{3,}\b/u);
            if (capsMatch && capsMatch[0]) return capsMatch[0];
            return '';
        },
        /**
         * Нормалізує ID до числа, якщо можливо
         */
        normalizeId(id) {
            if (id === null || id === undefined) return '';
            const num = Number(id);
            if (!Number.isNaN(num) && Number.isFinite(num)) return num;
            return ('' + id);
        },
        /**
         * Отримує поточну категорію з роуту
         */
        getCurrentCategoryFromRoute() {
            try {
                if (typeof window !== 'undefined' && window.$nuxt) {
                    const route = window.$nuxt.$route;
                    if (route && route.params && route.params.slug) {
                        return route.params.slug;
                    }
                }
                const path = window.location.pathname;
                const pathParts = path.split('/');
                const katalogIndex = pathParts.findIndex(part => part === 'katalog');
                if (katalogIndex !== -1 && pathParts[katalogIndex + 1]) {
                    return pathParts[katalogIndex + 1];
                }
                return '';
            } catch (e) {
                console.warn('Помилка отримання категорії з роуту:', e);
                return '';
            }
        },
        /**
         * Отримує назву категорії з каталогу за slug
         */
        getCategoryNameFromCatalog(slug) {
            if (!slug) return '';
            const catalogMap = {
                'monolitnii-polikarbonat': 'Монолітний полікарбонат',
                'profilyovanii-polikarbonat': 'Профільований полікарбонат',
                'sotovii-polikarbonat': 'Сотовий полікарбонат',
                'vstavka-do-pokrivli-iz-sendvich-paneli': 'Вставка до покрівлі із сендвіч панелі',
                'svitloprozori-fasadni-systemy': 'Світлопрозорі фасадні системи',
                'svitloprozori-pokrivelni-systemy': 'Світлопрозорі покрівельні системи',
                'aksessuary': 'Аксесуари',
                'rishennya-dlya-avtomobiliv': 'Рішення для автомобілів',
                'agroteplitsi': 'Агротеплиці'
            };
            return catalogMap[slug] || slug;
        },
        /**
         * Відправляє дані у dataLayer Google Analytics
         */
        sendToDataLayer(products) {
            if (!products || products.length === 0) {
                return;
            }
            // Відправляємо тільки через dataLayer (основний спосіб для GA4)
            if (window.dataLayer) {
                // Очищуємо попередні дані ecommerce
                window.dataLayer.push({ecommerce: null});
                const eventData = {
                    event: 'view_item_list',
                    ecommerce: { 
                        items: products 
                    }
                };
                if (this.productTracker?.listContext) {
                    eventData.item_list_name = this.productTracker.listContext.name;
                    eventData.item_list_id = this.productTracker.listContext.id;
                }
                window.dataLayer.push(eventData);
            } else {
                console.warn('ProductCarousel - dataLayer не доступний');
            }
        },
        /**
         * Оновлює відстеження при зміні списку товарів
         */
        updateCarouselTracking() {
            if (this.productTracker) {
                // Скидаємо флаги, щоб можна було відправити подію для нового списку
                this.hasTrackedCarousel = false;
                // Відключаємо попередній observer
                if (this.carouselObserver) {
                    this.carouselObserver.disconnect();
                    this.carouselObserver = null;
                }
                // Видаляємо всі обробники подій
                this.removeEventListeners();
                this.resetTracking();
                // Переініціалізуємо observer для нового списку
                this.initCarouselVisibilityObserver();
            }
        },
        /**
         * Видаляє всі обробники подій
         */
        removeEventListeners() {
            // Видаляємо обробники прокрутки та взаємодії
            window.removeEventListener('scroll', this.handleScroll);
            document.removeEventListener('touchstart', this.handleUserInteraction);
            document.removeEventListener('mousedown', this.handleUserInteraction);
        },
        prevSlide() {
            const c = this.$refs.carouselEl
            if (!c) return
            const prev = c.currentPage > 0 ? c.currentPage - 1 : c.pageCount - 1
            c.goToPage(prev)
        },
        nextSlide() {
            const c = this.$refs.carouselEl
            if (!c) return
            const next = c.currentPage < c.pageCount - 1 ? c.currentPage + 1 : 0
            c.goToPage(next)
        },
        ...mapMutations({})
    },
}  